import type { RefObject } from 'react'
import { useTranslation } from 'react-i18next'
import { AppIcon } from '../icons/AppIcon'
import { useFeedback } from './FeedbackContext'
import { FeedbackKindMenu } from './FeedbackKindMenu'

interface SidebarFeedbackButtonProps {
  isCollapsed: boolean
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  buttonRef?: RefObject<HTMLButtonElement>
}

export function SidebarFeedbackButton({
  isCollapsed,
  onMouseEnter,
  onMouseLeave,
  buttonRef,
}: SidebarFeedbackButtonProps) {
  const { isOpen, ready } = useFeedback()
  const { t } = useTranslation('dashboard')

  return (
    <FeedbackKindMenu
      placement="top-start"
      anchorClassName="w-full"
      trigger={
        <button
          ref={buttonRef}
          type="button"
          disabled={!ready}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          aria-label={t('sidebar.feedback.ariaLabel')}
          className={[
            'w-full flex-shrink-0 flex items-center gap-3',
            'h-[var(--app-bottom-chrome-height)]',
            'border-t border-[#171717]',
            isOpen ? 'bg-[#333333]' : 'bg-[#2a2a2a] hover:bg-[#333333]',
            'px-3',
            'text-sm text-white',
            'transition-colors',
            'focus:outline-none focus:ring-2 focus:ring-inset focus:ring-gray-600',
            'disabled:opacity-50 disabled:pointer-events-none',
            isCollapsed ? 'lg:justify-center' : '',
          ].join(' ')}
        >
          <span className="flex-shrink-0 w-7 h-7 rounded-md bg-[#0f0f0f] flex items-center justify-center">
            <AppIcon name="bug-beetle" size={16} className="text-white" />
          </span>
          <span className={`truncate text-left font-switzer ${isCollapsed ? 'lg:hidden' : ''}`}>
            {t('sidebar.feedback.label')}
          </span>
        </button>
      }
    />
  )
}
